import React from 'react';
import { connect } from 'react-redux';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
//components
import WidgetComponent from '../components/widget/WidgetComponent'
// import ApiFlow from '../components/api-flow/api-flow'
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './products.styl';
//media
import flow from '../media/flow.png';
import phone from '../media/phone.png';
//text
import { ProductsPageText as ProductsPageTextEN, Categories as CategoriesEN } from '../input-text/en/products_page';
import { ProductsPageText as ProductsPageTextNL, Categories as CategoriesNL  } from '../input-text/nl/products_page';

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.setLocale = this.setLocale.bind(this);
  }

  componentWillMount() {
      switch (this.props.lang) {
          case 'nl':
              this.props.setLocale(this.props.lang, true);
              break;
          default: this.props.setLocale(this.props.locale, true);
      }
  }

  componentWillUnmount() {
      this.props.setLocale(this.props.locale, false);
  }

  setLocale(locale) {
      this.ProductsPageText = null;
      this.Categories = null;
      switch (this.props.locale) {
          case 'en':
              this.ProductsPageText = ProductsPageTextEN;
              this.Categories = CategoriesEN;
              break;
          case 'nl':
              this.ProductsPageText = ProductsPageTextNL;
              this.Categories = CategoriesNL;
              break;
          default:
              this.ProductsPageText = ProductsPageTextEN;
              this.Categories = CategoriesEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <WidgetComponent aqi={100} isStatic={true}/>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{this.ProductsPageText._1}</h1>
            <p>{this.ProductsPageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='2' category={ this.Categories._1 } />
        <SimpleContainer color='white' containerClass='big-image-container'>
          <img src={phone} alt='mobile-img' />
        </SimpleContainer>
        <CategoryContainer cols='1' category={ this.Categories._2 } />
        <SimpleContainer color='white' containerClass='big-image-container'>
          <img src={flow} alt='placeholder' style={{ display: 'block', maxWidth: 1200, margin: 'auto' }}/>
          {/*
          <ApiFlow />
          */}
        </SimpleContainer>
        <div id="portfolio" style={{ paddingTop: 30 }}>
          <CategoryContainer cols='1' category={ this.Categories._3 } />
        </div>
        <CategoryContainer cols='1' category={ this.Categories._4 } />
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);



// WEBPACK FOOTER //
// ./src/routes/Products.js